// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB7hUFFjxLWZh3IorB2rt5s9kwFJ7D5BtA",
  authDomain: "metacollege-dev-login.firebaseapp.com",
  projectId: "metacollege-dev-login",
  storageBucket: "metacollege-dev-login.appspot.com",
  messagingSenderId: "678926080109",
  appId: "1:678926080109:web:ac211fe7719fe9c0fc4764"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(app);

// (Optional) Initialize Firestore
const db = getFirestore(app);

// Export the initialized services
export { auth, db };
